/* eslint-disable */
import Vue from "vue";

var updateText = function (el, binding, vnode) {
    var enableNumbersOnly = binding.value;
    var pattern = /[^\d]/g;
    if (enableNumbersOnly && el.value.length > 0) {
        let newValue = el.value.replace(pattern, '');
        el.value = newValue;

        binding.value = el.value;
    }
};
var isValid = function (ev) {
    var el = ev.currentTarget;
    return el.validity.valid || (el.value = '');
};
var preventUpdate = function (e) {
    let charCode = (e.which) ? e.which : e.keyCode;

    if (charCode === 46 || charCode > 31 && (charCode < 48 || charCode > 57)) {
        e.preventDefault();
    } else {
        return true;
    }
};

export const NumbersOnly = {
    inserted: function (el, binding, vnode) {
        updateText(el, binding, vnode);
    },
    bind(el, binding, vnode) {
        var enabled = binding.value;
        if (enabled) {
            el.valueChanged = function (event) {
                updateText(el, binding, vnode);
            };
            el.addEventListener('input', isValid);
            el.addEventListener('keypress', preventUpdate);
        }
    },
    unbind: function (el, binding) {
        var enabled = binding.value;
        if (enabled) {
            document.removeEventListener('input', isValid);
            document.removeEventListener('keypress', preventUpdate);
        }
    }
};

Vue.directive('numbers-only', NumbersOnly);